import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchManyLine} from "../../../api/api";

const initialState = {
    ManyLineData: [],
    loading: 'idle',
    error: null,
    isBrushActive: false,
};

export const fetchManyLineData = createAsyncThunk(
    'manylines/fetchManyLineData',
    async (options) => {
        options.newOKPDCode = options.selectedProduct.map(item => item.productId);
        const response = await fetchManyLine(options);
        if ((response.status === 204 && response.data === "") || response.data.result === null) {
            return [];
        }
        return response.data.result;
    }
);

const manyLineChartSlice = createSlice({
    name: 'manyLineChart',
    initialState,
    reducers: {
        resetManyLinesData: (state) => {
            return initialState;
        },
        toggleBrushActive: (state) => {
            state.isBrushActive = !state.isBrushActive;
        },
        resetBrushActive: (state) => {
            state.isBrushActive = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchManyLineData.pending, (state) => {
                state.loading = 'pending';
            })
            .addCase(fetchManyLineData.fulfilled, (state, action) => {
                if (Array.isArray(action.payload) && action.payload.length === 0) {
                    state.loading = 'failed';
                } else {
                    state.loading = 'successful';
                    state.ManyLineData = action.payload;
                }
            })
            .addCase(fetchManyLineData.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.error.message;
            })
    },
});
export const {toggleBrushActive, resetBrushActive,resetManyLinesData } = manyLineChartSlice.actions;

export default manyLineChartSlice.reducer;
